module.exports = __webpack_public_path__ + "img/ring_y_l_0_null@2x.e45ab020.png";